import { render, staticRenderFns } from "./modalChangeSource.vue?vue&type=template&id=08a31040&scoped=true"
import script from "./modalChangeSource.vue?vue&type=script&lang=js"
export * from "./modalChangeSource.vue?vue&type=script&lang=js"
import style0 from "./modalChangeSource.vue?vue&type=style&index=0&id=08a31040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a31040",
  null
  
)

export default component.exports